import React, { Component } from 'react'
import Icon from '../../elements/icon'
import { Localization } from '../../elements/icons'

import './licenseplate.scss'

class LicensePlate extends Component {

  renderNationality () {
    let icon = Localization.EU_Star
    return (
      <div className='nationality'>
        <div className='icon'>
          <Icon icon={icon} size='t' />
        </div>
        <div className='cc'>{this.props.countryCode}</div>
      </div>
    )
  }

  render () {
    return (
      <div className='licenseplate'>
        {this.renderNationality()}
        <div className='regnr'>{this.props.regNr}</div>
      </div>
    )
  }
}

LicensePlate.defaultProps = {
  regNr: 'XX 12 123',
  countryCode: 'dk'
}

export default LicensePlate



// WEBPACK FOOTER //
// ./src/app/shared/components/LicensePlate/index.js